import { useLazyQuery } from '@apollo/client';
import { useMemo } from 'react';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import {
  GetPreviewSalesOrderByBillingCycle,
  GetPreviewSalesOrderByBillingCycleVariables,
} from '@/graphql/contracts/_generated_/getPreviewSalesOrderByBillingCycle.query';
import GetPreviewSalesOrderByBillingCycleQuery from '@/graphql/contracts/getPreviewSalesOrderByBillingCycle.query.gql';
import { notificationService } from '@/services/notification/notification.client';
import { GetPreviewSalesOrderByBillingCycleInputType } from '@/graphql/contracts/_generated_/contracts';

export default function useGetPreviewSalesOrderByBillingCycle() {
  const [_getPreviewSalesOrder, { loading, error, data }] = useLazyQuery<
  GetPreviewSalesOrderByBillingCycle,
  GetPreviewSalesOrderByBillingCycleVariables
  >(GetPreviewSalesOrderByBillingCycleQuery, {
    client: apolloClientContracts,
    fetchPolicy: 'network-only',
    onError: (err) =>
      notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger',
      }),
  });

  const getPreviewSalesOrderByBillingCycle = async (
    input: GetPreviewSalesOrderByBillingCycleInputType
  ) => {
    const response = await _getPreviewSalesOrder({
      variables: { input },
    });

    return response.data?.getPreviewSalesOrderByBillingCycle;
  };

  return useMemo(
    () => ({
      getPreviewSalesOrderByBillingCycle,
      isLoadingPreviewSalesOrder: loading,
      errorPreviewSalesOrder: error,
      previewSalesOrder: data?.getPreviewSalesOrderByBillingCycle,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [loading, error, data?.getPreviewSalesOrderByBillingCycle]
  );
}
